<template>
  <v-container class="elevation-4">
    <v-snackbar
      v-model="snack"
      :timeout="5000"
      top
      :color="snackColor"
      class="text-capitalize"
    >
      {{ snackText }}
      <v-btn @click="snack = false" outlined>
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>

    <v-container>
      <v-app-bar app dense>
        <v-toolbar-title>New</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn text @click="createImmo" :disabled="!valid" color="primary">
          <v-icon large>save</v-icon>
        </v-btn>
      </v-app-bar>

      <v-container>
        <v-form ref="immoForm" v-model="valid">
          <v-text-field
            v-if="immo.meta.ref"
            :value="immo.meta.ref"
            label="Ref. No"
            readonly
            outline
          />
          <v-text-field v-model="immo.meta.ref_ext" label="Ref (ext)" />
          <v-text-field v-model="immo.info.title" label="Title" />
          <v-select
            :items="categories"
            v-model="immo.meta.categories"
            :rules="rules.categories"
            label="Categories"
            chips
            multiple
          ></v-select>
          <v-select
            :items="payment"
            v-model="immo.meta.payment"
            :rules="rules.paymen"
            label="Payment"
            chips
          ></v-select>
          <v-select
            :items="status"
            v-model="immo.meta.status"
            :rules="rules.status"
            label="Status"
            chips
          ></v-select>

          <v-textarea
            readonly
            auto-grow
            rows="2"
            :value="immo.location.address"
            label="Location"
            clearable
            clear-icon="close"
            @click:clear="clearLocation"
          >
            <template v-slot:prepend>
              <LocationPicker
                :location="immo.location"
                @new_location="setLocation"
              />
            </template>
          </v-textarea>

          <v-row>
            <v-col>
              <v-text-field
                v-model.number="immo.properties.price"
                label="Price"
              ></v-text-field>
              <v-text-field
                v-model.number="immo.properties.living"
                label="Living Area"
              ></v-text-field>
              <v-text-field
                v-model.number="immo.properties.bedrooms"
                label="Bedrooms"
                type="number"
              ></v-text-field>
              <v-text-field
                v-model.number="immo.properties.lawn"
                label="Lawn"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                v-model.number="immo.properties.build"
                label="Build Year"
              ></v-text-field>
              <v-text-field
                v-model.number="immo.properties.property"
                label="Property Area"
              ></v-text-field>
              <v-text-field
                v-model.number="immo.properties.bathrooms"
                label="Bathrooms"
                type="number"
              ></v-text-field>

              <v-text-field
                v-model.number="immo.properties.terrace"
                label="Terrace"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <v-switch label="Pool" v-model="immo.properties.pool"></v-switch>

              <v-switch
                label="Parking"
                v-model="immo.properties.parking"
              ></v-switch>
              <v-switch
                label="Garage"
                v-model="immo.properties.garage"
              ></v-switch>
              <!-- <v-switch
              label="Kitchen"
              v-model="immo.properties.kitchen"
              ></v-switch>-->
              <v-switch
                label="Rental Licence"
                v-model="immo.properties.rental"
              ></v-switch>
            </v-col>
            <v-col>
              <v-switch
                label="Sea Access"
                v-model="immo.properties.sea_access"
              ></v-switch>
              <v-switch
                label="Sea View"
                v-model="immo.properties.sea_view"
              ></v-switch>
              <v-switch label="Golf" v-model="immo.properties.golf"></v-switch>
              <v-switch
                label="Investment"
                v-model="immo.properties.investment"
              ></v-switch>
            </v-col>
          </v-row>

          <v-textarea
            v-model="immo.info.description"
            label="Description"
            auto-grow
          />
        </v-form>
      </v-container>
    </v-container>
  </v-container>
</template>

<script>
import ImmoService from '@/services/immo.service'
import LocationPicker from '@/components/map/LocationPicker'

export default {
  name: 'immoNew',
  components: {
    LocationPicker
  },
  data() {
    return {
      loaded: false,
      immo: {
        meta: { categories: ['VILLA'], payment: 'BUY', status: 'UNKNOWN' },
        info: {},
        location: {},
        properties: {}
      },

      valid: false,
      rules: {
        categories: [
          v => v.length > 0 || 'Select one or more categories',
          () => !this.errors.categories || this.errors.categories
        ],
        payment: [
          v => !!v || 'Select payment type',
          () => !this.errors.payment || this.errors.payment
        ],
        status: [
          v => !!v || 'Select status type',
          () => !this.errors.status || this.errors.status
        ]
      },
      errors: {},
      snack: false,
      snackColor: '',
      snackText: '',

      categories: [
        'VILLA',
        'APARTMENT',
        'FINCA',
        'PENTHOUSE',
        'COMMUNITY',
        'BUSINESS',
        'PLOT'
      ],
      status: ['INPROGRESS', 'AUTHORISED', 'CONTACT', 'UNKNOWN', 'SOLD'],
      payment: ['BUY', 'RENT']
    }
  },

  watch: {
    'immo.properties.garage'(newVal) {
        if (newVal) {
          this.immo.properties.parking = true
        }
      }
    },

  methods: {
    async createImmo() {
      if (this.$refs.immoForm.validate()) {
        try {
          this.errors = {}
          const res = await ImmoService.createImmo(this.immo)
          this.snackSuccess('immo created')
          this.$router.push(`/immo/${res.id}`)
        } catch (error) {
          console.log(error)
          this.errors = { ...error.fields }
          this.$refs.immoForm.validate()
          this.snackError(error.message)
        }
      }
    },

    setLocation(loc) {
      this.immo.location = loc
    },
    clearLocation() {
      this.immo.location = { address: '', lat: 0.0, lng: 0.0 }
    },

    snackSuccess(message) {
      this.snack = true
      this.snackColor = 'success'
      this.snackText = message
    },
    snackError(message) {
      this.snack = true
      this.snackColor = 'error'
      this.snackText = message
    }
  }
}
</script>
